<app-modal-container
  [buttons]="modalButtons"
  (applyButtonClicked)="confirm()"
  (closeButtonClicked)="close()"
  (dismissButtonClicked)="close()"
  [title]="'Edit organization'"
  [applyActivated]="orgForm.valid">
  <form [formGroup]="orgForm" class="vertical-container-simple column-gap-1">
    <div class="row-container row-gap-1">
      <div class="modal-column-width vertical-container-simple column-gap-1">
        <app-input data-qa="org-name"
          formControlName="name"
          [title]="'Name'"
          [required]="true">
        </app-input>
        <app-input data-qa="org-id"
          formControlName="organizationId"
          [title]="'ID'"
          [disabled]="true">
        </app-input>
      </div>
      <app-upload #upload data-qa="logo-upload-input"
        class="max-width-20"
        formControlName="logo"
        [widthHeight]="'width-13 height-9'"
        (deleteOldLink)="orgForm.patchValue({ logo: undefined })">
      </app-upload>
    </div>
    <div class="aligned-column-container column-gap-1">
      <app-input data-qa="org-website"
        formControlName="website"
        [title]="'Website'">
      </app-input>
      <app-input data-qa="org-linkedIn"
        formControlName="linkedIn"
        [title]="'LinkedIn'">
      </app-input>
      <app-input data-qa="org-address"
        formControlName="address"
        [title]="'Headquarters address'">
      </app-input>
    </div>
  </form>
</app-modal-container>
